import { Component } from '@angular/core';

@Component({
    selector: 'leaflet-layer',
    template: '',
    standalone: false
})
export class LeafletLayerComponent {
}
